import Loading from 'vue-loading-overlay';
import Toasted from 'vue-toasted';
import VModal from 'vue-js-modal';
import VueTailwind from 'vue-tailwind';
import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'vue-loading-overlay/dist/vue-loading.css';
import { createProvider } from './vue-apollo';

// eslint-disable-next-line
import aws_exports from './aws-exports';

Amplify.configure(aws_exports);

Vue.use(Toasted);
Vue.use(Loading);
Vue.component('loading', Loading);
const settings = {
  TSelect: {
    fixedClasses: 'form-select',
    classes: '',
    variants: {
      danger: 'border-red-300 bg-red-100',
      success: 'border-green-300 bg-green-100',
    },
  },
  TTable: {
    classes: {
      table: 'shadow rounded-lg min-w-full divide-y divide-gray-200',
      tbody: 'bg-white divide-y divide-gray-200',
      td: 'px-6 py-4 truncate overflow-hidden text-sm leading-5 text-gray-700',
      theadTh:
        'px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-700 uppercase tracking-wider',
    },
  },
  TButton: {
    fixedClasses:
      'focus:outline-none focus:shadow-outline inline-flex items-center transition ease-in-out duration-150',
    classes:
      'text-white bg-blue-600 hover:bg-blue-500 focus:border-blue-700 active:bg-blue-700 text-sm font-medium border border-transparent px-3 py-2 rounded-md',
    variants: {
      error:
        'text-white bg-red-600 hover:bg-red-500 focus:border-red-700  active:bg-red-700 text-sm font-medium border border-transparent px-3 py-2 rounded-md',
      success:
        'text-white bg-green-400 hover:bg-green-300 focus:border-green-700 active:bg-green-700 text-sm font-medium border border-transparent px-3 py-2 rounded-md',
      link: 'underline text-orange-500 px-3 py-2 hover:bg-orange-100 rounded',
    },
  },
  TModal: {
    fixedClasses: {
      overlay:
        'z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50 flex',
      wrapper: 'z-50 relative mx-auto my-auto max-w-lg lg:max-w-6xl',
      modal: 'bg-white shadow overflow-hidden relative',
      body: 'p-4',
      header: 'p-4  text-sm font-semibold uppercase text-gray-700',
      footer: 'p-4 text-sm font-semibold uppercase text-gray-700 flex justify-center',
      close: 'absolute right-0 top-0 m-3 text-gray-700 hover:text-gray-600',
      closeIcon: 'h-5 w-5 fill-current',
    },
    classes: {
      overlay: 'bg-black ',
      wrapper: '',
      modal: '',
      body: 'p-4',
      header: 'text-gray-700 border-b',
      footer: 'border-t ',
      close: 'text-gray-700 hover:text-gray-600',
      closeIcon: '',
    },
    variants: {
      danger: {
        overlay: 'bg-red-500',
        header: 'border-red-100 text-red-700 border-b',
        footer: 'border-red-100 bg-red-100 border-t  ',
        close: 'text-red-700 hover:text-red-600',
      },
      clean: {
        modal: 'rounded shadow-lg',
        footer: 'bg-gray-100 ',
        body: 'p-4 text-sm text-gray-700',
        close:
          'bg-blue-100 p-1 flex items-center justify-center leading-normal rounded-full text-blue-80 hover:bg-blue-200',
      },
    },
  },
};

Vue.use(VueTailwind, settings);

Vue.use(VModal, { dialog: true });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
